var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "handover-takeback" }, [
    _vm.loading
      ? _c("h6", { staticClass: "font-dark-gray" }, [
          _c("i", { staticClass: "rotation fa fa-refresh" }),
          _vm._v("\n    " + _vm._s(_vm.$t("loading")) + "\n  "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.hotbs && _vm.hotbs.length > 0,
            expression: "hotbs && hotbs.length > 0",
          },
        ],
      },
      [
        _c("div", { staticClass: "handover-takeback__title" }, [
          _vm._v("\n      " + _vm._s(_vm.$t("handoverTakeback")) + "\n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "handover-takeback__table" }, [
          _c("table", { staticClass: "sort_table" }, [
            _c("thead", [
              _c(
                "tr",
                { staticClass: "handover-takeback__table--header" },
                _vm._l(_vm.tableHeaders, function (header) {
                  return _c(
                    "th",
                    {
                      key: header.name,
                      class: header.className,
                      on: {
                        click: function ($event) {
                          return _vm.sortTable(header)
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n                " +
                            _vm._s(header.name) +
                            "\n                "
                        ),
                        _vm.sortingAttr === header.attr
                          ? _c("i", {
                              class: [
                                _vm.reverse ? "triangle-down" : "triangle-up",
                              ],
                            })
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.sortedHotbs, function (hotb) {
                return _c(
                  "tr",
                  {
                    key: hotb.id,
                    staticClass: "handover-takeback__table--body",
                  },
                  [
                    _c("td", [
                      _vm._v(_vm._s(hotb.companyName || _vm.emptyValue)),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(hotb.tradeName || _vm.emptyValue)),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm._f("customTProjectTypeLabel")(hotb.type))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(hotb.building || _vm.emptyValue))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          staticClass: "link_text",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.navToDetail(hotb.id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(hotb.premises || _vm.emptyValue) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm._f("customStatusLabel")(hotb.status))),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.dateUtil.format(
                            hotb.scheduledTransactionDate,
                            "DD MMM YY, HH:mm"
                          ) || _vm.emptyValue
                        )
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }